import { Component, Input, OnChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ingsv-adm-roadmap',
  templateUrl: './roadmap.component.html',
  styleUrls: ['./roadmap.component.scss']
})
export class RoadmapComponent implements OnChanges {
  @Input() roadmapData = [];

  checkedIndex = -1;

  ngOnChanges(changes: any) {
    if (this.roadmapData && this.roadmapData.length) {
      this.setRoadmapCheckedIndex();
    }
  }

  private setRoadmapCheckedIndex(): void {
    this.checkedIndex = -1;
    this.roadmapData.forEach((roadmapStep, index) => {
      if (roadmapStep.checked) {
        this.checkedIndex = index;
      }
    });
  }
}
